import Footer from "../Footer";
import Navbar from "../Navbar";
import CategoryBody from "../CategoryBody";

export default function CategoryPage(){
    return(
        <div>
            <Navbar />
            <div data-aos="fade-up" data-aos-delay="0">
        <CategoryBody />
    </div>
            <Footer />

        </div>


    )


}